import { Grid, Button, Box, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import { useEffect, useState } from "react"
import { useAppDispatch } from "@/lib/hooks"
import { logout } from "@/redux/slices/authSlice"
import { apiFetch } from "@/hooks/apiFetch"
import { toast } from "sonner"

const LogoutContent = () => {
  const dispatch = useAppDispatch()

  // State to store API response
  const [response, setResponse] = useState(null)

  useEffect(() => {
    const handleLogout = async () => {
      try {
        const data = await apiFetch("logout", {
          method: "POST",
        })
        setResponse(data)
      } catch (error) {
        console.error("Logout failed:", error)
      }
    }

    handleLogout()
  }, [])

  // Dispatch the logout action once response is received
  useEffect(() => {
    if (response) {
      dispatch(logout())
      toast.success("Logged out")
    }
  }, [response, dispatch])

  return (
    <Box className="auth-main-wrapper forgot-password-area" sx={{ padding: 5 }}>
      <Box
        sx={{
          maxWidth: { sm: "500px", md: "1255px" },
          mx: "auto",
          px: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          columnSpacing={{ xs: 1, sm: 2, md: 4, lg: 3 }}
        >
          <Grid item xs={12} md={6} lg={6} xl={7}>
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <img
                src="/images/logout.jpg"
                alt="logout"
                width={500}
                height={400}
                style={{ borderRadius: "24px" }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6} lg={6} xl={5}>
            <Box
              className="form-content"
              sx={{ paddingLeft: { xs: "0", lg: "10px" } }}
            >
              <Box className="logo" sx={{ mb: "23px" }}>
                <img
                  src="/images/logo-big.svg"
                  alt="logo"
                  width={142}
                  height={38}
                />
                <img
                  src="/images/white-logo.svg"
                  className="d-none"
                  alt="logo"
                  width={142}
                  height={38}
                />
              </Box>

              <Box className="title" sx={{ mb: "23px" }}>
                <Typography
                  variant="h1"
                  className="text-black"
                  sx={{
                    fontSize: {
                      xs: "22px",
                      sm: "25px",
                      lg: "28px",
                    },
                    mb: "10px",
                    fontWeight: "600",
                  }}
                >
                  Welcome back to POS!
                </Typography>
                <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                  You Are Logged out
                </Typography>
              </Box>

              <Link to="/login">
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    textTransform: "capitalize",
                    borderRadius: "6px",
                    fontWeight: "500",
                    fontSize: { xs: "13px", sm: "16px" },
                    padding: {
                      xs: "10px 20px",
                      sm: "10px 24px",
                    },
                    color: "#fff !important",
                    boxShadow: "none",
                    width: "100%",
                  }}
                >
                  <i className="material-symbols-outlined mr-5">autorenew</i>
                  Sign In
                </Button>
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default LogoutContent
